<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData"></Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <!-- <el-table-column prop="ledgerBatch" label="	单据批次"/> -->
      <el-table-column prop="createTime" :label="$t('activity.list.createTime')" width="160"/>
      <el-table-column prop="ledgerBatch" :label="$t('equipment.sale.entryTime')" width="160"/>
      <el-table-column prop="action" :label="$t('equipment.sale.action')" width="100"/>
      <el-table-column prop="robotSerialNumber" :label="$t('activity.packetjoin.robotCode')"/>
      <el-table-column prop="cabinetSerialNumber" :label="$t('collect.healthscorelist.ctrlCabCode')"/>
      <el-table-column prop="cabinetProgram" :label="$t('equipment.cabinet.cabinetProgram')"/>
      <el-table-column prop="robotServoProgram" :label="$t('equipment.cabinet.servoProgram')"/>
      <!-- <el-table-column prop="appVersion" :label="$t('equipment.cabinet.appVersion')"/> -->
      <el-table-column prop="customer" :label="$t('activity.detail.customer')" width="120"/>
      <el-table-column prop="notes" :label="$t('equipment.cabinet.remarks')"/>
      <!-- <el-table-column prop="operator" label="操作人"/> -->
      <el-table-column :label="$t('activity.list.operation')" fixed="right" width="100">
        <template #default="scope">
          <el-button v-show="authList.includes('sale:edit')" type="text" @click="editRobot(scope.row)">{{$t('activity.list.edit')}}</el-button>
        </template>
      </el-table-column>
    </Table>
    <el-dialog top="5vh" v-model="dialogFormVisible" destroy-on-close :modal="true" :append-to-body="true">
      <el-form ref="formRef" class="dialog-form" :model="form" :rules="formRules" :label-width="curLang == 'zh-CN' ? '150px' : curLang == 'en-US' ? '240px' : '220px'">
        <el-form-item :label="$t('equipment.sale.robotProdBatch')" prop="robotProductionBach">
          <el-input v-model="form.robotProductionBach" :placeholder="$t('equipment.sale.enterRobotProdBatch')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('activity.packetjoin.robotCode')" prop="robotSerialNumber">
          <el-input v-model="form.robotSerialNumber" :placeholder="$t('activity.packetjoin.robotCode')"/>
        </el-form-item>
        <el-form-item :label="$t('equipment.sale.robotServoProgram')" prop="robotServoProgram">
          <el-input v-model="form.robotServoProgram" :placeholder="$t('equipment.sale.enterRobotServoProgram')"/>
        </el-form-item>
        <el-form-item :label="$t('equipment.sale.cabinetProdBatch')" prop="cabinetProductionBatch">
          <el-input v-model="form.cabinetProductionBatch" :placeholder="$t('equipment.sale.enterCabinetProdBatch')"/>
        </el-form-item>
        <el-form-item :label="$t('collect.healthscorelist.ctrlCabCode')" prop="cabinetSerialNumber">
          <el-input v-model="form.cabinetSerialNumber" :placeholder="$t('collect.healthscorelist.ctrlCabCode')"/>
        </el-form-item>
        <el-form-item :label="$t('equipment.cabinet.cabinetProgram')" prop="cabinetProgram">
          <el-input v-model="form.cabinetProgram" :placeholder="$t('equipment.cabinet.cabinetProgram')"/>
        </el-form-item>
        <el-form-item :label="$t('equipment.cabinet.appVersion')" prop="appVersion">
          <el-input v-model="form.appVersion" :placeholder="$t('equipment.cabinet.appVersion')"/>
        </el-form-item>
        <el-form-item :label="$t('activity.detail.customer')" prop="customer">
          <el-input v-model="form.customer" :placeholder="$t('activity.detail.customer')"/>
        </el-form-item>
        <el-form-item :label="$t('equipment.cabinet.remarks')">
          <el-input v-model="form.notes" :placeholder="$t('equipment.cabinet.remarks')"/>
        </el-form-item>
        <el-form-item :label="$t('equipment.sale.operator')">
          <el-input v-model="form.operator" :placeholder="$t('equipment.sale.operator')"/>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" size="small" @click="onSubmit">{{$t('activity.list.confirm')}}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { request } from '@/utils/request';
import { common } from '@/common/mixin';
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import { ElMessage } from "element-plus";
import { computed } from "vue";
import { useStore } from "vuex"
// import { useI18n } from 'vue-i18n'
// const { t } = useI18n()
export default {
  components: {
    Table,
    Filter
  },
  mixins: [common],
  data() {
    const store = useStore()
    return {
      dialogFormVisible: false,
      formRef: null,
      form: {
        robotProductionBach: '',
        robotSerialNumber: '',
        robotServoProgram: '',
        cabinetProductionBatch: '',
        cabinetSerialNumber: '',
        cabinetProgram: '',
        province: '',
        appVersion: '',
        customer: '',
        notes: '',
        operator: '',
        saleTime: ''
      },
      formRules: {
        robotProductionBach: {
          required: true,
          message: this.$t('equipment.sale.enterRobotProdBatch'),
          trigger: 'blur',
        },
        robotSerialNumber: {
          required: true,
          message: this.$t('equipment.robot.enterRobotCode'),
          trigger: 'blur',
        },
        robotServoProgram: {
          required: true,
          message: this.$t('equipment.sale.enterRobotServoProgram'),
          trigger: 'blur'
        },
        cabinetProductionBatch: {
          required: true,
          message: this.$t('equipment.sale.enterCabinetProdBatch'),
          trigger: 'blur',
        },
        cabinetSerialNumber: {
          required: true,
          message: this.$t('equipment.sale.enterCabinetCode'),
          trigger: 'blur',
        },
        cabinetProgram: {
          required: true,
          message: this.$t('equipment.sale.enterCabinetProgram'),
          trigger: 'blur',
        },
        appVersion: {
          required: true,
          message: this.$t('equipment.sale.enterAppVersion'),
          trigger: 'blur',
        },
        customer: {
          required: true,
          message: this.$t('equipment.sale.enterCustomer'),
          trigger: 'blur',
        }
      },
      params: [{
        key: 'robotSerialNumber',
        value: '',
        label: this.$t('activity.packetjoin.robotCode')
      },{
        key: 'customer',
        value: '',
        label: this.$t('activity.detail.customer')
      },{
        key: 'cabinetSerialNumber',
        value: '',
        label: this.$t('collect.healthscorelist.ctrlCabCode')
      },{
        key: 'cabinetProgram',
        value: '',
        label: this.$t('equipment.cabinet.cabinetProgram')
      }],
      query: {},
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [],
      provinceList: [],
      cityList: [],
      areaList: [],
      robotStatusList: [], // 机器人状态下拉列表
      industryList: [], // 行业下拉列表
      curLang: computed(() => store.state.lang),
      authList: JSON.parse(window.localStorage.getItem('authList'))
    }
  },
  watch: {
    "query.province": function(value, old) {
      if (value && (value!==old)) {
        console.log('province', value)
        request('getArea', {
          parentId: Number(value)
        })
        .then((data) => {
          this.cityList = data;
        })
      }
    },
    "query.city": function(value, old) {
      if (value && (value!==old)) {
        request('getArea', {
          parentId: Number(value)
        })
        .then((data) => {
          this.areaList = data;
        })
      }
    }
  },
  created() {
    window.$this = this;
    this.getData()
    // this.getDataMap()
  },
  mounted () {
    // this.tableDataList = robotList({}).then(data => {
    //   this.tableDataList = data
    // })
    // this.$store.dispatch('status/robot', {})
    // .then(data => {
    //   console.log(data)
    // })
    // robotList({}).then(data => {
    //   this.tableDataList = data
    // })
  },
  methods: {
    getData() {
      request('getLedgerList', {
        ...this.query,
        page: this.page,
        size: this.size
      })
      .then((data) => {
        this.tableDataList = data.records;
        this.total = data.total;
        // this.tableDataList = [].concat(data.records);
      })
      .catch((error) => {
        console.log(error);
      })
    },
    getDataMap() {
      try {
        request('getArea', {
          parentId: 1
        })
        .then((data) => {
          this.provinceList = data;
        })
        request('getRobotStatusMap')
        .then((data) => {
          this.robotStatusList = data;
        })
        request('getIndustryList')
        .then((data) => {
          this.industryList = data;
        })
      } catch (error) {
        console.log(error)
      }
    },
    searchData(data) {
      this.query = data
      this.getData()
    },
    updatePage(page, size) {
        this.page = page || 1
        this.size = size || 10
        this.getData()
    },
    addNewRobot() {
      for (let key of Object.keys(this.form)) {
        this.form[key] = ''
      }
      this.dialogFormVisible = true
    },
    editRobot(data) {
      console.log(data)
      for (let key of Object.keys(this.form)) {
        if (data[key]) {
          this.form[key] = data[key]
        } else {
          this.form[key] = ''
        }
      }
      this.form.id = data.id
      this.dialogFormVisible = true
      return
    },
    async onSubmit() {
      try {
        this.$refs.formRef && await this.$refs.formRef.validate()
        const api =  this.form.id ? 'updateLedger' : 'addLedger'
        await request(api, this.form)
        ElMessage({
          showClose: true,
          type: "success",
          message: this.$t('activity.list.submitSuccess')
        })
        this.dialogFormVisible = false
        this.getData()
      } catch (error) {
        console.error(error)
      }    
    },
    onCancel () {
      this.dialogFormVisible = false
      
    },
    dateChange() {
      console.log('dateChange: ', this.dateRange)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
